export enum ProIntent {
    Light = 'white',
    Dark = 'black',
    Primary = 'primary',
    PrimaryLight = 'primary-light',
    Tertiary = 'tertiary',
    Secondary = 'secondary',
    Warning = 'warning',
    Error = 'error',
    Success = 'success',
    Create = 'create',
    Transparent = 'transparent',
    Gray = 'gray-light',
    LightBlue = 'blue-lighter',
    Edit = 'edit',
    // SecondaryLight = 'secondary-light',
}

export enum ProSize {
    XSmall = 'xs',
    Small = 's',
    Medium = 'm',
    Large = 'l',
    XLarge = 'xl',
}
